<template>
  <mdb-navbar position="top" color="red" dark :transparent="transparency" scrolling>
    <mdb-navbar-brand to="/">
      <img
        class="pentagon-brand"
        src="../assets/pentagon-logo.png"
        alt="pentagon-wapen"
      />
    </mdb-navbar-brand>
    <mdb-navbar-toggler style="max-width: 1140px">
      <mdb-navbar-nav left>
        <mdb-nav-item waves-fixed active to="/">Home</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Leden">Leden</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Bestuur">Bestuur</mdb-nav-item>
        <mdb-nav-item waves-fixed to="/Gallerij">Foto's</mdb-nav-item>
        <mdb-nav-item waves-fixed href="https://pentagonamsterdam.nl/login">Login</mdb-nav-item>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbContainer,
  mdbNavbar,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbNavbarBrand,
  mdbInput,
} from 'mdbvue';

export default {
  name: 'NavBar',
  components: {
    mdbContainer,
    mdbNavbar,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbNavbarBrand,
    mdbInput,
  },
  computed: {
    transparency() {
      return this.$store.state.navbar.transparent;
    }
  }
};
</script>

<style>
  .pentagon-brand {
    height: 50px;
    width: 50px;
  }
</style>
